import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { applyFont } from "./fonts";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULTS = {
  phone: "+221 78 113 05 16",
  phone_e164: "+221781130516",
  whatsapp_e164: "221781130516",
  email: "queenswaysn@gmail.com",
  instagram_url: "https://www.instagram.com/queensway_studio/",
  instagram_handle: "@queensway_studio",
  location_dakar: "Dakar, Sénégal",
  location_london: "London, United Kingdom",
  deposit_fcfa: 10000,
  deposit_method: "Orange Money",
  hours: {
    sunday: { open: "10:00", close: "19:30", closed: false },
    monday: { open: "", close: "", closed: true },
    tuesday: { open: "10:00", close: "19:30", closed: false },
    wednesday: { open: "10:00", close: "19:30", closed: false },
    thursday: { open: "10:00", close: "19:30", closed: false },
    friday: { open: "10:00", close: "19:30", closed: false },
    saturday: { open: "10:00", close: "19:30", closed: false },
  },
  hero_title_en: "Quiet luxury, refined beauty.",
  hero_title_fr: "Le luxe discret de la beauté.",
  hero_subtitle_en:
    "An intimate aesthetics atelier — bespoke treatments crafted with London-certified expertise, in the heart of Dakar.",
  hero_subtitle_fr:
    "Un atelier d'esthétique intimiste — des soins sur mesure, signés par une expertise certifiée à Londres, au cœur de Dakar.",
  about_body_en: "",
  about_body_fr: "",
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: async () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/settings/public`);
      setSettings((prev) => ({ ...prev, ...res.data }));
    } catch {
      // keep defaults
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Apply admin-chosen colour palette to CSS variables when settings arrive.
  // Empty string = restore whatever the stylesheet set originally.
  useEffect(() => {
    const root = document.documentElement;
    const apply = (varName, value) => {
      if (value && typeof value === "string" && value.trim()) {
        root.style.setProperty(varName, value.trim());
      } else {
        root.style.removeProperty(varName);
      }
    };
    apply("--primary", settings.color_primary_hsl);
    apply("--accent", settings.color_accent_hsl);
    apply("--background", settings.color_background_hsl);
  }, [settings.color_primary_hsl, settings.color_accent_hsl, settings.color_background_hsl]);

  // Apply admin-chosen fonts (empty = defaults from the stylesheet).
  useEffect(() => {
    applyFont("heading", settings.font_heading);
    applyFont("body", settings.font_body);
  }, [settings.font_heading, settings.font_body]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
